export default "__VITE_ASSET__22db1a82__"